import { Tag } from '../Tag';

function HistoryCheckTag() {
  return (
    <Tag text="History Checked" textColor="GREY_DARK" bgColor="GREY_LIGHTER" />
  );
}

export { HistoryCheckTag };
